import { render } from "./payment.vue?vue&type=template&id=5ce9df40&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=5ce9df40&lang=scss&scoped=true"
import "./payment.vue?vue&type=style&index=1&id=5ce9df40&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce9df40"]])

export default __exports__